import * as THREE from "three";
import type { Avatar } from "./avatar";

/** Conversation facing is relative to locomotion, never the camera or world Y.
 * Feet follow travel while moving; standing players turn to their partner. */
export class ConversationLook {
  private yaw = 0;
  private readonly direction = new THREE.Vector3();
  private readonly eye = new THREE.Vector3();
  private readonly inverse = new THREE.Quaternion();
  private readonly turn = new THREE.Quaternion();
  private readonly up = new THREE.Vector3(0, 1, 0);

  update(actor: Avatar, partner: Avatar | null, locomotion: THREE.Quaternion, moving: boolean, dt: number): void {
    let desired = 0;
    if (partner) {
      this.direction.copy(partner.group.position).sub(actor.group.position)
        .applyQuaternion(this.inverse.copy(locomotion).invert());
      if (!moving && this.direction.lengthSq() > 0.01) desired = Math.atan2(-this.direction.x, -this.direction.z);
      const head = partner.humanoidBone("head");
      if (head) { head.updateWorldMatrix(true, false); head.getWorldPosition(this.eye); }
      else this.eye.set(0, 1.6, 0).applyQuaternion(partner.group.quaternion).add(partner.group.position);
      actor.setHeadLookTarget(this.eye, true);
    } else actor.setHeadLookTarget(null);
    const delta = Math.atan2(Math.sin(desired - this.yaw), Math.cos(desired - this.yaw));
    this.yaw += delta * (1 - Math.exp(-10 * Math.max(0, dt)));
    this.yaw = Math.atan2(Math.sin(this.yaw), Math.cos(this.yaw));
    actor.group.quaternion.copy(locomotion).multiply(this.turn.setFromAxisAngle(this.up, this.yaw));
  }
}
